import React, { Component } from "react";
import PropTypes from 'prop-types';
import Header from '../Header/Header.jsx';
import MainPageContainer from '../MainPageContainer/MainPageContainer.jsx';
import Footer from '../Footer/Footer.jsx';
import ErrorToast from '../ErrorToast';
import MainModal from '../MainModal';

class MainPagesLayout extends Component {
  static propTypes = {
    className: PropTypes.any,
    children: PropTypes.any.isRequired
  };

  render() {
    return (
      <div id='mainPagesLayout'>
        <div className='content-top'>
          <Header />
          <div className={'content-area' + (this.props.className ? ' ' + this.props.className : '')}>
            <ErrorToast />
            <MainPageContainer>
              {this.props.children}
            </MainPageContainer>
            <MainModal />
          </div>
        </div>
        <footer className='footer'>
          <Footer />
        </footer>
      </div>
    );
  }
}

export default MainPagesLayout;
